import { render, staticRenderFns } from "./zhuanzhang.vue?vue&type=template&id=6ce4a354&scoped=true"
import script from "./zhuanzhang.vue?vue&type=script&lang=js"
export * from "./zhuanzhang.vue?vue&type=script&lang=js"
import style0 from "./zhuanzhang.vue?vue&type=style&index=0&id=6ce4a354&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce4a354",
  null
  
)

export default component.exports